import React, { Component } from 'react';
import CommonFunctions from './CommonFunctions';

export default class SettingsPanel extends Component {

	saveSettings() {
		/*
		CommonFunctions.saveSetting(
				'spreadsheetWithPhrasesUrl',
				this.spreadsheetWithPhrasesUrl.value);
		*/
		CommonFunctions.saveSetting(
				'readingDelayInLearning', this.readingDelayInLearning.value);
		CommonFunctions.saveSetting(
				'minWordsInPhrase', this.minWordsInPhrase.value);
		CommonFunctions.saveSetting(
				'maxWordsInPhrase', this.maxWordsInPhrase.value);
		this.props.app.setState({ mode: 'main' });
	} // saveSettings

	render() {
		return (
			<div>
				<div style={{ fontSize: 'xx-large' }}>Settings</div>
				<div style={{
						marginTop: 60,
						padding: 10,
						textAlign: 'left' }}>
					{/*
					Spreadsheet with phrases:&nbsp;
					<input
						ref={(r) => { this.spreadsheetWithPhrasesUrl = r; }}
						type="text"
						size="60"
						defaultValue={
							CommonFunctions.getSpreadsheetWithPhrasesUrl()} />

					<div className='spreadsheet-control'>

						<span
							className="link"
							onClick={() => {
								if (this.spreadsheetWithPhrasesUrl.value !== '') {
									var win = window.open(
										this.spreadsheetWithPhrasesUrl.value,
										'_blank');
									if (win) win.focus();
								}
							}}>
							Open
						</span>&nbsp;

						<span
							className="link"
							onClick={()=> {
								this.spreadsheetWithPhrasesUrl.value =
									CommonFunctions.getSpreadsheetWithEnglishPhrasesUrl();
							}}>
							English phrases
						</span>

					</div>
					*/}
					<table>
						<tbody>
							<tr>
								<td>Reading delay in learning:&nbsp;</td>
								<td>
									<input
										ref={(r) => { this.readingDelayInLearning = r; }}
										type="number"
										min="10"
										max="60000"
										step="10"
										defaultValue={CommonFunctions.getSetting(
											'readingDelayInLearning', '800')} /> ms
								</td>
							</tr>

							<tr>
								<td>Minimum words in phrase:&nbsp;</td>
								<td>
									<select
											ref={(r) => {this.minWordsInPhrase = r;}}
											defaultValue={CommonFunctions.getSetting(
													'minWordsInPhrase', 'Unlimited')} >
										{ ['2', '3', "4", '5', 'Unlimited'].map(
											(v, i) => <option key={i}>{v}</option>)
										}
									</select>
								</td>
							</tr>

							<tr>
								<td>
									Maximum words in phrase:&nbsp;
								</td>
								<td>
									<select
											ref={(r) => { this.maxWordsInPhrase = r; }}
											defaultValue={CommonFunctions.getSetting(
													'maxWordsInPhrase', '2')} >
										{ CommonFunctions.createSelectOptions(
										['1', '2', '3', "4", '5', 'Unlimited']) }
									</select>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<div style={{
						position: 'absolute',
						bottom: 10,
						width: '90%' }}>

					<table width="100%">
						<tbody>
							<tr>
								<td>
									<button onClick={() => {
											this.props.app.setState(
													{ mode: 'dictionariesSettings' });
											}}>
										Dictionaries settings
									</button>

									<button
											style={{ marginLeft: 5 }}
											onClick={() => {
												this.props.app.setState(
														{ mode: 'voiceSettings' });
											}}>
										Voice settings
									</button>
								</td>
								<td align="right">

									<button onClick={() => {
												this.saveSettings();
											}}>
										Save
									</button>

									<button
											style={{ marginLeft: 5 }}
											onClick={() => {
												this.props.app.setState(
														{ mode: 'main' });
											}}>
										Close
									</button>

								</td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		);
	} // render
} // class SettingsPanel



// WEBPACK FOOTER //
// ./src/SettingsPanel.js